export const menuSystem = {
  none: 'none',
  simplified: 'simplified',
  complete: 'complete',
};
